<template>
  <Loader :stretch="true" :inverse="true"></Loader>
</template>

<script lang="ts">
import useApplications from "@/use/application";
import { defineComponent, computed } from "vue";
import { useRoute } from "vue-router";
import { mapActions, mapGetters, mapState, useStore } from "vuex";
import Loader from "../components/shared/Loader.vue";
import { $api } from "@/services/api";

export default defineComponent({
  setup() {
    const store = useStore();
    const route = useRoute();

    const { getUserApplications } = useApplications();
		
    const creditUnions = computed(() => store.state.applicationsModule?.creditUnions);

    return { getUserApplications, route, store, creditUnions };
  },
  components: {
    Loader,
  },
  computed: {
    ...mapState(["applications"]),
    ...mapGetters("oidcStore", ["oidcUser"]),
  },
  methods: {
    ...mapActions(["setApplications"]),
    async getUserInfo() {
      const query = this.route.query as any;

      const userApps = await this.getUserApplications(this.oidcUser.sub);
      this.setApplications(userApps);

      if (this.creditUnions?.length > 1) {
        this.$router.push({
          path: `/applications/lenders`,
          query,
        });
      } else if (this.applications.length === 1) {
        // set slc-lid
        localStorage.setItem("slc-lid", this.applications[0].lenderId);
        this.$router.push({
          path: `/applications/${this.applications[0].referenceId}`,
          query,
        });
      } else {
        // Assuming they have more than one we send them to applcations instead
        this.$router.push({ path: "/applications", query });
      }
    },
  },
  async mounted() {
    console.log("Home component mounted", this.oidcUser);
    await this.getUserInfo();
  },
});
</script>
